<template>
  <div class="main-content">
    <div class="card" v-if="allowToEdit">
      <div class="card-body">
        <form @submit.prevent="saveUser">
          <div class="flex flex_gap_10 flex-wrap">
            <div class="form-group">
              <label for="">Тип пользователя</label>
              <select v-model="newUser.type" class="form-control">
                <option v-for="(t, id) in userTypes" :value="id">{{ t }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">ФИО</label>
              <input v-model="newUser.title" required class="form-control"/>
            </div>
            <div class="form-group" v-for="(d, index) in usersData" v-if="d.groups.includes(+newUser.type)">
              <label for="">{{ d.title }}</label>
              <input v-model="newUser.data[index]" class="form-control"/>
            </div>
          </div>
          <div class="form-group">
            <label for="">Коммментарий</label>
            <textarea class="form-control" rows="3" v-model="newUser.data.comment"/>
          </div>
          <div class="mt-2">
            <UploadCustomWithPreview
              ref="filesUpload"
              :allowToUpload="false"
              :extraData="{object: 'service_post_user', objectId: newUser.id}"
            />
          </div>
          <div class="flex flex_gap_10 justify-content-end mt-2">
            <button type="button" @click="resetUser" class="btn btn-default">Сбросить данные</button>
            <LoadingButton
              title="Сохранить"
              type="submit"
              :loading="saveLoading"
              :color="$constants.SUCCESS_COLOR"
              :onClick="() => {}"
              className="btn btn-outline-success"
            />
          </div>
        </form>
      </div>
    </div>
    <div class="card">
      <div class="card-header">
        <h5>Пользователи для сервисов</h5>
      </div>
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && records">
          <table class="table mt-0 table-sm table-hover">
            <thead>
            <tr>
              <th></th>
              <th>тип</th>
              <th>Дроп</th>
              <th width="45%">файлы</th>
              <th>создан</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r,i) in records">
              <td>{{ i + 1 }}</td>
              <td>{{ userTypes[r.type] }}</td>
              <td>
                <p>{{ r.title }}</p>
                <div v-for="(d, alias) in usersData" v-if="r.data?.[alias]">
                  <template v-if="(allowToEdit && alias === 'price') || alias !== 'price'">
                    <template v-if="alias === 'price'">
                      <p v-if="r.data?.price">{{ d.title }}: <strong>{{ r.data.price }}</strong></p>
                    </template>
                    <template v-else-if="alias === 'payLink'">
                      <p v-if="allowToEdit && r.data?.payLink"><a target="_blank" :href="r.data.payLink">оплата</a></p>
                    </template>
                    <template v-else-if="alias === 'comment'">
                      <div class="white_space" v-html="r.data[alias]"/>
                    </template>
                    <template v-else>
                      <p :class="d.classes">{{ d.title }}: {{ r.data[alias] }}</p>
                    </template>
                  </template>
                </div>
              </td>
              <td>
                <UploadImages
                  v-if="(r.files ?? []).length"
                  :showImages="false"
                  :blockUpload="true"
                  :files="r.files"
                />
              </td>
              <td align="center">
                <button v-if="allowToEdit" @click="editUser(r.id)" class="btn btn-default mb-1">Редактировать</button>
                <p>{{ printDate(r.created_at) }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import UploadCustomWithPreview from "@/components/images/UploadCustomWithPreview.vue";
import UploadImages from "@/components/uploads/UploadImages.vue";

export default {
  title: 'Дропы',
  components: {UploadImages, UploadCustomWithPreview, LoadingButton},
  data() {
    return {
      loading: false,
      saveLoading: false,
      allowToEdit: false,
      userTypes: {
        1: 'СДЭК ID',
        2: 'ПЭП почта',
        3: 'Банк аккаунт',
      },
      usersData: {
        phone: {title: 'Телефон', classes: ['fs-18', 'font-weight-bold'], groups: [1, 2, 3]},
        phone_owner: {title: 'У кого телефон', groups: [1, 2, 3]},
        price: {title: 'Стоимость', groups: [1, 2, 3]},
        payLink: {title: 'Оплата', groups: [1, 2, 3]},
        card_num: {title: 'Номер карты', groups: [3]},
        card_expiration: {title: 'Срок действия', groups: [3]},
        card_cvv: {title: 'CVV карты', groups: [3]},
        card_pin: {title: 'PIN карты', groups: [3]},
        card_pass_code: {title: 'Кодовое слово', groups: [3]},
        bank_login: {title: 'Логин в сбер', groups: [3]},
        bank_pass: {title: 'Пароль в сбер', groups: [3]},
        fio_eng: {title: 'ФИО ENG', groups: [3]},
        address: {title: 'Адрес прописки', groups: [3]},
        comment: {title: 'Комментарий', groups: []},
      },
      newUserDefault: {
        id: null,
        type: 1,
        title: '',
        phone: '',
        phone_owner: '',
        price: '',
        payLink: '',
        data: {},
      },
      newUser: {},
      records: null,
    }
  },
  created() {
    this.allowToEdit = this.$can('services/postUsers/Edit');
    this.resetUser();
    this.getRecords();
  },
  methods: {
    resetUser() {
      this.newUser = {...this.newUserDefault};
    },
    editUser(id) {
      const user = (this.records ?? []).find((u) => u.id === id);
      if (!user) return;
      this.newUser = {
        ...user,
        data: user.data
      }
      this.$refs.filesUpload.files = [];
    },
    async saveUser() {
      this.saveLoading = true;
      const {data} = await api.post('/new/services/postusers', {
        user: this.newUser
      })
      if (data.success) {
        this.newUser.id = data.record.id;
        this.$refs.filesUpload.data.object_id = data.record.id;
        this.newUser = {...this.newUser};
        console.log(this.$refs.filesUpload.data.object_id);
        setTimeout(() => {
          this.$refs.filesUpload.$refs.upload.active = true;
          setTimeout(() => {
            let checkInterval = setInterval(() => {
              if (!this.$refs.filesUpload.$refs.upload.active) {
                clearInterval(checkInterval);
                const uploadCheck = this.$refs.filesUpload.$refs.upload.files.find((f) => !f.success);
                if (uploadCheck) {
                  toastr['warning']('некоторые файлы не загружены', 'Неуспешно')
                } else {
                  toastr['success']('Сохранено');
                  this.resetUser();
                  this.$refs.filesUpload.files = [];
                  this.getRecords();
                }
                this.saveLoading = false;
              }
            }, 500)
          }, 1000);
        }, 1000)
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
        this.saveLoading = false;
      }
    },
    async getRecords() {
      this.loading = true;
      const {data} = await api.index('/new/services/postusers');
      if (data.success) {
        this.records = data.records;
      } else {
        toastr['warning'](data.message || 'ошибка сервера', 'Неуспешно')
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.white_space{
  white-space: break-spaces;
}
</style>
